import _ from 'lodash';
import React from 'react';

import { FlexLayout, Icon, Text } from '~/ui';

const currentYear = new Date().getFullYear();
const years = _.range(2014, currentYear + 30);

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const CustomDateInput = React.forwardRef(
  ({ onClick, placeholder, value, dateRangeValue, width, height = 'input-height' }, ref) => (
    <FlexLayout
      alignItems="center"
      px={4}
      ref={ref}
      sx={{ border: 'border', borderRadius: 'm', height, width }}
      onClick={onClick}
    >
      <Text color="deep-sapphire" variant="m-spaced">
        {dateRangeValue || value || placeholder}
      </Text>
    </FlexLayout>
  )
);

export function renderCustomHeader({
  date,
  changeYear,
  changeMonth,
  decreaseMonth,
  increaseMonth,
  prevMonthButtonDisabled,
  nextMonthButtonDisabled,
}) {
  return (
    <FlexLayout alignItems="center" px={3} py={4} space={1}>
      <Icon
        color="bali-hai"
        disabled={prevMonthButtonDisabled}
        icon="arrowLeft"
        size="xs"
        sx={{ '&:hover': { color: !prevMonthButtonDisabled && 'deep-sapphire' } }}
        onClick={decreaseMonth}
      />
      <FlexLayout alignItems="center" justifyContent="center" flexGrow="1" space={1}>
        <select
          value={months[date.getMonth()]}
          onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}
        >
          {months.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
          {years.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </FlexLayout>

      <Icon
        color="bali-hai"
        disabled={nextMonthButtonDisabled}
        icon="arrowRight"
        size="xs"
        sx={{ '&:hover': { color: !nextMonthButtonDisabled && 'deep-sapphire' } }}
        onClick={increaseMonth}
      />
    </FlexLayout>
  );
}

export function setDate(date) {
  if (!date) return null;

  if (typeof date === 'string' && /^\d{4}\/\d{2}\/\d{2}$/.test(date)) {
    const [year, month, day] = date.split('/');
    return new Date(Number(year), Number(month) - 1, Number(day));
  }

  if (typeof date === 'string') {
    const utcDate = new Date(date);
    const year = utcDate.getUTCFullYear();
    const month = utcDate.getUTCMonth();
    const day = utcDate.getUTCDate();

    const localDate = new Date(year, month, day);

    return localDate;
  }

  return date;
}
